module.exports = __webpack_public_path__ + "images/emails/attachment-c211456d.png";